export const CURRENCY_SYMBOLS: { [key: string]: string } = {
    EUR: '€',
    USD: '$',
    GBP: '£'
};
